import { SalesLineViewModel, ReturnModeRequest, ShippingDocumentLineViewModel,InventoryJournalLineViewModel } from "../Types/ExportTypes";

export const generateVariantLabel = (line: SalesLineViewModel) => {
    if (!line.variantId) {
        return "";
    }

    const parts = [];


    if (line.colourCode) {
        parts.push(line.colourCode);
    }

    if (line.colourDescription) {
        parts.push(line.colourDescription);
    }


    if (line.sizeDescription) {
        parts.push(line.sizeDescription);
    }


    if (line.lengthDescription) {
        parts.push(line.lengthDescription);
    }


    const details = parts.join(" | ");


    return `${line.variantId} | ${details || "No Details Available"}`;
};

export const generateVariantLabelFromReturnMode = (line?: ReturnModeRequest | null) => {
    if (!line) return "";
    if (!line.variantId) {
        return "";
    }

    const parts = [];

    if (line.colour) {
        parts.push(line.colour);
    }


    if (line.size) {
        parts.push(line.size);
    }


    if (line.length) {
        parts.push(line.length);
    }


    const details = parts.join(" | ");


    return `${line.variantId} | ${details || "No Details Available"}`;
};


export const generateVariantLabelFromShipment = (line?: ShippingDocumentLineViewModel | null) => {
    if (!line) return "";
    if (!line.variantId) {
        return "";
    }

    const parts = [];

    if (line.colourDescription) {
        parts.push(line.colourDescription);
    }


    if (line.sizeDescription) {
        parts.push(line.sizeDescription);
    }


    if (line.lengthDescription) {
        parts.push(line.lengthDescription);
    }


    const details = parts.join(" | ");


    return `${line.variantId} | ${details || "No Details Available"}`;
};


export const generateInventoryJournalLineVariantLabel = (line: InventoryJournalLineViewModel) => {
    if (!line.variantId) {
        return "";
    }

    const parts = [];


    if (line.colorCode) {
        parts.push(line.colorCode);
    }

    if (line.colorDesc) {
        parts.push(line.colorDesc);
    }


    if (line.sizeDesc) {
        parts.push(line.sizeDesc);
    }


    if (line.lengthDesc) {
        parts.push(line.lengthDesc);
    }


    const details = parts.join(" | ");


    return `${line.variantId} | ${details || "No Details Available"}`;
};